module.exports = __webpack_public_path__ + "img/euro centro de idiomas.08a0abfd.svg";